// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}

.header {
  color: white;
  background: #990636;
  height: 64px;
  padding: 0 16px;
}

.header-second {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 34px 0 48px;
  background: url('payment_success_header.png'), linear-gradient(180deg, #990636 49%, #f2f2f2 0%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.preorder_type {
  border-radius: 28px;
  background: var(--ion-color-tertiary);
  color: white;
  padding: 4px 14px;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 19px;
}
.preorder_type h3 {
  font-family: AppFont600, sans-serif;
  color: white;
  font-size: 24px;
  text-transform: capitalize;
}

.order-number {
  color: #fff;
  font-family: Tusker;
  font-size: 32px;
  margin-bottom: 10px;
}
.order-number span {
  color: #ec6825;
  font-family: Tusker;
  font-size: 32px;
}

.thank-text {
  color: #fff;
  font-family: AppFontBold;
  font-size: 18px;
}

.brand-logo {
  height: 80px;
  width: 300px;
  margin-top: 20px;
}

.brand-desc {
  margin: 0px;
  margin-top: 5px;
  color: var(--ion-color-black);
  text-align: center;
  font-size: 14px;
  line-height: 17px;
}

app-burger-btn {
  position: absolute;
  right: 0;
  top: 0;
}

ion-footer {
  width: auto;
}
ion-footer ion-button {
  font-size: 18px;
  font-family: AppFont, san-serif;
}

ion-footer {
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-footer {
    width: 100%;
    align-self: center;
  }
}

ion-card {
  background: transparent;
  box-shadow: none;
  word-break: break-word;
  --color: black;
  --preorder-type-chip-border-color: var(--ion-color-primary);
}
ion-card ion-card-content {
  padding: 10px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

app-preorder-type-chip {
  --preorder-type-chip-border-color: var(--ion-color-dark);
  --preorder-type-chip-background: var(--ion-color-dark) !important;
  --preorder-type-chip-color: var(--ion-color-primary);
}

ion-chip {
  background: var(--ion-color-primary);
  color: white;
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  margin: 0px;
  font-size: 11px;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-weight: bold;
}

.header-wrap {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px !important;
  font-family: AppFontBold, sans-serif;
}

.price-title {
  font-size: 16px;
  font-weight: 700;
}

.ticket-number {
  text-align: center;
}
.ticket-number h2 {
  font-family: var(--font-tusker), sans-serif !important;
  font-size: 29px;
  line-height: 35px;
  color: var(--ion-color-primary);
  letter-spacing: 1.2px;
}
.ticket-number h2 .code {
  color: var(--ion-color-tertiary);
  font-family: AppFontBold, sans-serif !important;
  font-size: 29px;
  line-height: 35px;
  letter-spacing: 1px;
}
.ticket-number h4 {
  font-family: Caveat, sans-serif !important;
  font-size: 20px;
  line-height: 30px;
  color: var(--ion-color-primary);
  font-weight: bold;
}

ion-footer ion-button {
  font-size: 16px;
}

ion-col {
  color: var(--ion-color-subtitle);
  font-family: AppFont400, sans-serif;
}
ion-col b,
ion-col h3,
ion-col ion-card-title {
  text-align: left !important;
  color: #521340;
  font-family: AppFont600;
  font-size: 14px;
}

.think {
  color: #521340;
  font-family: AppFont600;
  font-size: 12px;
}

.text-right {
  text-align: right;
}

.hint_text {
  color: var(--ion-color-medium);
  font-family: AppFont, san-serif;
  padding: 0px 11px;
  margin: 10px 0px;
  font-size: 12px;
  text-align: center;
}

.price {
  color: #521340;
  font-family: AppFontBold !important;
  font-size: 16px !important;
  text-transform: capitalize;
}

.separator {
  background: url('border-line.svg') center/100% 99% no-repeat;
  height: 2px;
}

.table_preorder {
  position: absolute;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  top: 0px;
}

.uppercase {
  text-transform: uppercase;
}

.article_name {
  color: #521340;
  font-family: AppFontBold;
  font-size: 16px;
}

.article_name_total {
  color: #646464;
  font-family: AppFont, sans-serif !important;
}

.article_name_total_right {
  text-align: right;
}

.total_block {
  width: 100%;
  padding: 0px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total_block_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hint_text {
  color: black;
}

.tip_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,gBAAA;AADD;;AAIA;EACC,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,+FAAA;EACA,4BAAA;EACA,0BAAA;AADD;;AAIA;EACC,mBAAA;EACA,qCAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;AADD;AAGC;EACC,mCAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AADF;;AAKA;EACC,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAFD;AAIC;EACC,cAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAMA;EACC,WAAA;EACA,wBAAA;EACA,eAAA;AAHD;;AAMA;EACC,YAAA;EACA,YAAA;EACA,gBAAA;AAHD;;AAOA;EACC,WAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;AAJD;;AAOA;EAEC,WAAA;AALD;AAMC;EACC,eAAA;EACA,+BAAA;AAJF;;AAQA;EACC,gBAAA;AALD;ACpFE;EDwFF;IAIE,WAAA;IACA,kBAAA;EAJA;AACF;;AAOA;EACC,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,2DAAA;AAJD;AAMC;EACC,aAAA;EACA,2BAAA;AAJF;AAME;EACC,YAAA;AAJH;;AASA;EACC,wDAAA;EACA,iEAAA;EACA,oDAAA;AAND;;AAQA;EACC,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;AALD;;AAOA;EACC,yBAAA;EACA,iCAAA;EACA,iBAAA;AAJD;;AAMA;EACC,aAAA;EACA,mBAAA;AAHD;;AAKA;EACC,0BAAA;EACA,oCAAA;AAFD;;AAIA;EACC,eAAA;EACA,gBAAA;AADD;;AAGA;EACC,kBAAA;AAAD;AAEC;EACC,sDAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EAEA,qBAAA;AADF;AAEE;EACC,gCAAA;EACA,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAH;AAGC;EACC,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;AADF;;AAKC;EACC,eAAA;AAFF;;AAKA;EACC,gCAAA;EACA,mCAAA;AAFD;AAGC;;;EAGC,2BAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EAEA,uBAAA;EACA,eAAA;AAFF;;AAIA;EACC,iBAAA;AADD;;AAIA;EACC,8BAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AADD;;AAIA;EACE,cAAA;EACA,mCAAA;EACA,0BAAA;EACA,0BAAA;AADF;;AAIA;EACC,4DAAA;EACA,WAAA;AADD;;AAGA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;AAAD;;AAEA;EACC,yBAAA;AACD;;AACA;EACC,cAAA;EACA,wBAAA;EACA,eAAA;AAED;;AACA;EACC,cAAA;EACA,2CAAA;AAED;;AAAA;EACC,iBAAA;AAGD;;AADA;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAID;;AAFA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAKD;;AAHA;EACC,YAAA;AAMD;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAMF","sourcesContent":["@import '../../../theme/mixins';\n\nion-header {\n\tbox-shadow: none;\n}\n\n.header {\n\tcolor: white;\n\tbackground: #990636;\n\theight: 64px;\n\tpadding: 0 16px;\n}\n\n.header-second {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 34px 0 48px;\n\tbackground: url(../../../assets/tabilo/payment_success_header.png), linear-gradient(180deg, #990636 49%, #f2f2f2 0%);\n\tbackground-repeat: no-repeat;\n\tbackground-size: 100% 100%;\n}\n\n.preorder_type {\n\tborder-radius: 28px;\n\tbackground: var(--ion-color-tertiary);\n\tcolor: white;\n\tpadding: 4px 14px;\n\twidth: fit-content;\n\tmargin-bottom: 19px;\n\n\th3 {\n\t\tfont-family: AppFont600, sans-serif;\n\t\tcolor: white;\n\t\tfont-size: 24px;\n\t\ttext-transform: capitalize;\n\t}\n}\n\n.order-number {\n\tcolor: #fff;\n\tfont-family: Tusker;\n\tfont-size: 32px;\n\tmargin-bottom: 10px;\n\n\tspan {\n\t\tcolor: #ec6825;\n\t\tfont-family: Tusker;\n\t\tfont-size: 32px;\n\t}\n}\n\n.thank-text {\n\tcolor: #fff;\n\tfont-family: AppFontBold;\n\tfont-size: 18px;\n}\n\n.brand-logo {\n\theight: 80px;\n\twidth: 300px;\n\tmargin-top: 20px;\n\n\t// margin-left: 15px;\n}\n.brand-desc {\n\tmargin: 0px;\n\tmargin-top: 5px;\n\tcolor: var(--ion-color-black);\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 17px;\n}\n\napp-burger-btn {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n}\n\nion-footer {\n\t// height: 12vh;\n\twidth: auto;\n\tion-button {\n\t\tfont-size: 18px;\n\t\tfont-family: AppFont, san-serif;\n\t}\n}\n\nion-footer {\n\tbox-shadow: none;\n\n\t@include desktop {\n\t\twidth: 100%;\n\t\talign-self: center;\n\t}\n}\n\nion-card {\n\tbackground: transparent;\n\tbox-shadow: none;\n\tword-break: break-word;\n\t--color: black;\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\n\tion-card-content {\n\t\tpadding: 10px;\n\t\tline-break: auto !important;\n\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n\napp-preorder-type-chip {\n\t--preorder-type-chip-border-color: var(--ion-color-dark);\n\t--preorder-type-chip-background: var(--ion-color-dark) !important;\n\t--preorder-type-chip-color: var(--ion-color-primary);\n}\nion-chip {\n\tbackground: var(--ion-color-primary);\n\tcolor: white;\n\theight: 20px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n\ttext-transform: uppercase;\n\tfont-family: AppFontBold, sans-serif;\n\tmargin: 0px;\n\tfont-size: 11px;\n}\n.your-order-title {\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary);\n\tfont-weight: bold;\n}\n.header-wrap {\n\tdisplay: flex;\n\talign-items: center;\n}\n.title {\n\tfont-size: 18px !important;\n\tfont-family: AppFontBold, sans-serif;\n}\n.price-title {\n\tfont-size: 16px;\n\tfont-weight: 700;\n}\n.ticket-number {\n\ttext-align: center;\n\n\th2 {\n\t\tfont-family: var(--font-tusker), sans-serif !important;\n\t\tfont-size: 29px;\n\t\tline-height: 35px;\n\t\tcolor: var(--ion-color-primary);\n\n\t\tletter-spacing: 1.2px;\n\t\t.code {\n\t\t\tcolor: var(--ion-color-tertiary);\n\t\t\tfont-family: AppFontBold, sans-serif !important;\n\t\t\tfont-size: 29px;\n\t\t\tline-height: 35px;\n\t\t\tletter-spacing: 1px;\n\t\t}\n\t}\n\th4 {\n\t\tfont-family: Caveat, sans-serif !important;\n\t\tfont-size: 20px;\n\t\tline-height: 30px;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: bold;\n\t}\n}\nion-footer {\n\tion-button {\n\t\tfont-size: 16px;\n\t}\n}\nion-col {\n\tcolor: var(--ion-color-subtitle);\n\tfont-family: AppFont400, sans-serif;\n\tb,\n\th3,\n\tion-card-title {\n\t\ttext-align: left !important;\n\t\tcolor: #521340;\n\t\tfont-family: AppFont600;\n\t\tfont-size: 14px;\n\t}\n}\n.think {\n  color: #521340;\n\n  font-family: AppFont600;\n  font-size: 12px;\n}\n.text-right {\n\ttext-align: right;\n}\n\n.hint_text {\n\tcolor: var(--ion-color-medium);\n\tfont-family: AppFont, san-serif;\n\tpadding: 0px 11px;\n\tmargin: 10px 0px;\n\tfont-size: 12px;\n\ttext-align: center;\n}\n\n.price {\n  color: #521340;\n  font-family: AppFontBold !important;\n  font-size: 16px !important;\n  text-transform: capitalize;\n}\n\n.separator {\n\tbackground: url('../../../assets/tabilo/border-line.svg') center / 100% 99% no-repeat;\n\theight: 2px;\n}\n.table_preorder {\n\tposition: absolute;\n\tz-index: 999;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\ttop: 0px;\n}\n.uppercase {\n\ttext-transform: uppercase;\n}\n.article_name {\n\tcolor: #521340;\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n}\n\n.article_name_total {\n\tcolor: #646464;\n\tfont-family: AppFont, sans-serif !important;\n}\n.article_name_total_right {\n\ttext-align: right;\n}\n.total_block {\n\twidth: 100%;\n\tpadding: 0px 5px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n.total_block_info {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n.hint_text {\n\tcolor: black;\n}\n\n.tip_row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
